<ng-container *ngIf="selectedPlatform$ | async as selectedPlatform">
  <div [ngSwitch]="selectedPlatform">
    <div *ngSwitchCase="Platforms.Meta">
      <aayn-select-an-ad-type--header [url]="facebookUrl"></aayn-select-an-ad-type--header>
    </div>

    <div *ngSwitchCase="Platforms.Google">
      <aayn-select-an-ad-type--header [url]="googleUrl"></aayn-select-an-ad-type--header>
    </div>

    <div *ngSwitchCase="Platforms.Bing">
      <aayn-select-an-ad-type--header [url]="bingUrl"></aayn-select-an-ad-type--header>
    </div>

    <div *ngSwitchCase="Platforms.LinkedIn">
      <aayn-select-an-ad-type--header [url]="linkedinUrl"></aayn-select-an-ad-type--header>
    </div>

    <div *ngSwitchCase="Platforms.TikTok">
      <aayn-select-an-ad-type--header [url]="tiktokUrl"></aayn-select-an-ad-type--header>
    </div>

    <div *ngSwitchCase="Platforms.SmartCampaign">
      <aayn-select-an-ad-type--header
        [url]="smartCampaignAdCreationModel.ad.websiteUrl"
      ></aayn-select-an-ad-type--header>
    </div>
  </div>
</ng-container>
